import { render, staticRenderFns } from "./confirmAddress.vue?vue&type=template&id=e00725f8&scoped=true"
import script from "./confirmAddress.vue?vue&type=script&lang=js"
export * from "./confirmAddress.vue?vue&type=script&lang=js"
import style0 from "./confirmAddress.vue?vue&type=style&index=0&id=e00725f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00725f8",
  null
  
)

export default component.exports